import { render, staticRenderFns } from "./PiHoleStats.vue?vue&type=template&id=371e80f5&scoped=true&"
import script from "./PiHoleStats.vue?vue&type=script&lang=js&"
export * from "./PiHoleStats.vue?vue&type=script&lang=js&"
import style0 from "./PiHoleStats.vue?vue&type=style&index=0&id=371e80f5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371e80f5",
  null
  
)

export default component.exports